import { useQuery } from "@tanstack/react-query";
import { blogService } from "@/services/blog";
import { readBlogSsrData } from "@/shared/blog/ssrData";
import { blogKeys } from "./queryKeys";

/** Hub público do cluster (E1.5): o cluster e seus posts publicados, pilar primeiro. */
export const usePublishedCluster = (slug: string | undefined) =>
  useQuery({
    queryKey: blogKeys.publishedCluster(slug ?? ""),
    queryFn: () => blogService.getPublishedCluster(slug as string),
    enabled: Boolean(slug),
    // Primeiro render com o que o SSR já entregou: sem esqueleto e sem
    // depender da API para mostrar a página (ver src/shared/blog/ssrData.ts).
    // A busca segue acontecendo em segundo plano e atualiza se algo mudou.
    initialData: () => {
      const ssr = readBlogSsrData();
      return ssr?.kind === "cluster" && ssr.slug === slug ? ssr.hub : undefined;
    },
  });
